export default {
  lessons: [],
  lesson: {},
};
